var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.normalized.length
    ? _c("section", { staticClass: "status-change-section" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "status-timeline" },
          [
            _vm._l(_vm.visibleRecords, function (item, index) {
              return [
                _c(
                  "div",
                  {
                    key: "item-" + item.key,
                    staticClass: "status-item",
                    class: "type-" + item.type,
                  },
                  [
                    _c("div", { staticClass: "status-head" }, [
                      _c("span", { staticClass: "status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "status-title" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "status-tag",
                          class: "tag-" + item.type,
                        },
                        [_vm._v(_vm._s(item.tag))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "status-time" }, [
                        _vm._v(_vm._s(item.operateTime)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "status-summary",
                          on: {
                            click: function ($event) {
                              return _vm.toggleExpand(item.key)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "summary-text" }, [
                            _vm._v(_vm._s(item.summary)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "summary-toggle" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.expandedMap[item.key] ? "收起" : "展开"
                                ) +
                                "\n              "
                            ),
                            _c("i", {
                              class: _vm.expandedMap[item.key]
                                ? "el-icon-arrow-up"
                                : "el-icon-arrow-down",
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandedMap[item.key],
                              expression: "expandedMap[item.key]",
                            },
                          ],
                          staticClass: "status-fields",
                        },
                        _vm._l(item.fields, function (field, idx) {
                          return _c(
                            "div",
                            { key: idx, staticClass: "status-field" },
                            [
                              _c("span", { staticClass: "field-label" }, [
                                _vm._v(_vm._s(field.label)),
                              ]),
                              _vm._v(" "),
                              field.isFile && field.value !== "--"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "field-file",
                                      attrs: { href: "javascript:;" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onFileClick(field)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(field.value))]
                                  )
                                : _c("span", { staticClass: "field-value" }, [
                                    _vm._v(_vm._s(field.value || "--")),
                                  ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                index === 0 && _vm.normalized.length > 1
                  ? _c(
                      "div",
                      {
                        key: "more-toggle",
                        staticClass: "more-toggle",
                        class: { "is-open": _vm.showAll },
                        on: {
                          click: function ($event) {
                            _vm.showAll = !_vm.showAll
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.showAll
                                ? "收起其他操作记录"
                                : "查看更多操作记录"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          class: _vm.showAll
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _c("i", { staticClass: "el-icon-time" }),
      _vm._v(" "),
      _c("span", [_vm._v("月卡状态变更记录")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }